import type { ContentsListRow } from "@/admin/entities/contents";
import type { ContentsListQueryQueryType } from "@/types/graphql/admin.generated";

/**
 * Мапперы для feature управления контентом
 * Используют конкретные типы из GraphQL кодгена
 */

// Трансформация данных GraphQL ответа в формат для таблицы
// CRUD компонент ожидает (data: unknown) => TableData<Row>
export function getTableData(data: unknown): {
  nodes: ContentsListRow[];
  count: number;
} {
  const contents = (data as ContentsListQueryQueryType)?.contents;

  if (!contents || !contents.nodes) {
    return { nodes: [], count: 0 };
  }

  return contents;
}

// Маппинг данных единицы контента в формат для отображения в таблице
export function mapColumns(content: ContentsListRow) {
  return [
    content.id,
    content.preview,
    content,
    content.platform,
    content.processingStatus,
    content.publishAt,
    content.createdAt,
    content.deletedAt,
  ];
}
